import React from 'react';
import classNames from 'classnames';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  ButtonWrapper,
} from '../../../components';

import './style.scss';

const ParagraphTextImage = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const linkTitle = entity.getIn(['field_link', 0, 'title']);
  const linkUri = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const imgSrc = entity.getIn(['field_image', 0, 'styles', 'cropped_small_4_3']);
  const imgAlt = entity.getIn(['field_image', 0, 'title']);
  const body = entity.getIn(['field_body', 0, 'processed']);
  const id = entity.get('target_id');
  const flipped = entity.getIn(['field_flipped', 0, 'value']);

  const paragraphTextImageFlipped = classNames('ParagraphTextImage__inner__content', {
    ParagraphTextImage__inner__content__flipped: flipped,
  });

  return (
    <Container>
      <div className="ParagraphTextImage">
        <div className="ParagraphTextImage__inner">
          <div className={`${paragraphTextImageFlipped} row`}>
            { imgSrc && imgAlt && (
              <div className={`ParagraphTextImage__inner__content__image col-12 col-md-4 col-lg-4 ${flipped ? 'order-2 offset-md-1' : ''}`}>
                <img src={imgSrc} alt={imgAlt} />
              </div>
            )}
            <div className={`ParagraphTextImage__inner__content col-12 col-md-7 col-lg-7  ${flipped ? '' : 'offset-md-1'}`}>
              {title && (
                <h2 className="ParagraphText__title">{title}</h2>
              )}
              <div className="ParagraphTextImage__inner__content__body">
                <WysiwygField
                  property="schema:text"
                  html={body}
                  key={`paragraph:${id}`}
                />
              </div>
              { linkTitle && linkUri && (
                <div className="ParagraphTextImage__inner__button">
                  <ButtonWrapper type="tertiary" href={linkUri}>{linkTitle}</ButtonWrapper>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ParagraphTextImage;
